import React, { useState } from "react";
import { useTheme } from "../../Hooks/UseData";
import ShareButtons from "./ShareButtons";

const ModelCard = ({ model, onClick }) => {
    const [isHovered, setIsHovered] = useState(false);
    const [imgError, setImgError] = useState(false);
    const themeColor = useTheme();

    // Generate a gradient based on the model name hash for variety
    const getGradient = (name) => {
        const hash = name.split('').reduce((acc, char) => acc + char.charCodeAt(0), 0);
        const hue = hash % 360;
        return `linear-gradient(135deg, hsl(${hue}, 60%, 50%) 0%, hsl(${hue + 60}, 60%, 40%) 100%)`;
    };

    return (
        <div
            className="portfolio-card"
            onClick={() => onClick(model)}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            data-aos="fade-up"
            data-aos-duration="1200"
        >
            <div className="portfolio-card-inner">
                {/* 3D Model Preview Container */}
                <div className="portfolio-card-preview">
                    <ShareButtons modelName={model.name} />
                    {model.thumbnailUrl && !imgError ? (
                        <img
                            className="model-thumbnail"
                            src={model.thumbnailUrl}
                            alt={`${model.name} 3D model`}
                            loading="lazy"
                            onError={() => setImgError(true)}
                        />
                    ) : (
                        <div
                            className="model-placeholder"
                            style={{ background: getGradient(model.name) }}
                        >
                            <div className="model-icon">
                                <i className="fa fa-cube"></i>
                            </div>
                        </div>
                    )}

                    {/* Hover Overlay */}
                    <div className={`portfolio-card-overlay ${isHovered ? 'active' : ''}`}>
                        <div className="overlay-content">
                            <i className="fa fa-eye"></i>
                            <p>View in 3D</p>
                        </div>
                    </div>
                </div>

                {/* Card Info */}
                <div className="portfolio-card-info">
                    <h4 className="model-name">{model.name}</h4>
                    <div className="model-meta">
                        <span className="meta-item">
                            <i className="fa fa-file"></i>
                            {formatFileSize(model.size)}
                        </span>
                        <span className="meta-item">
                            <i className="fa fa-cube"></i>
                            STL
                        </span>
                    </div>
                </div>

                {/* View Button */}
                <div className="portfolio-card-action">
                    <button className="view-btn" style={{ borderColor: themeColor }}>
                        <span className="btn-text">View Model</span>
                        <span className="btn-icon fa fa-arrow-right"></span>
                    </button>
                </div>
            </div>
        </div>
    );
};

// Helper function to format file size
const formatFileSize = (bytes) => {
    if (bytes === 0) return '0 B';
    const k = 1024;
    const sizes = ['B', 'KB', 'MB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return Math.round((bytes / Math.pow(k, i)) * 100) / 100 + ' ' + sizes[i];
};

export default ModelCard;
